var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        { attrs: { id: item.id, "data-jstree": _vm.defineType(item.type) } },
        [
          _vm._v("\n        " + _vm._s(_vm.getName(item)) + "\n        "),
          item[_vm.field] && item[_vm.field].length > 0
            ? _c("role-tree-acl", {
                attrs: { field: _vm.field, items: item[_vm.field] },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }